import React, { useContext } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import cn from 'classnames'
import { ModalContext } from 'modaaals'
import { useQuery } from '@apollo/client'

import * as Icon from './Icons'
import SelectionContext from '../context/SelectionContext'
import Logo from './LogoPixedenMusic'
import CoversWall from './CoversWall'
import { QUERY } from '../apollo'

import '../reboot.css'
import styles from './layout.module.css'

function Layout({ children, hero, heroClassName }) {
  const { openModal } = useContext(ModalContext)
  const { selectionState } = useContext(SelectionContext)

  return (
    <div className={styles.wrapper}>
      <div className={cn(styles.hero, heroClassName)}>
        <CoversWall />

        <header className={styles.header}>
          <nav className={cn(styles.containerOut, styles.nav)}>
            <div className={styles.menu}>
              <Link to="/" className={styles.logo}>
                <Logo />
              </Link>
            </div>
            <div className={styles.menu}>
              <div className={styles.navItem}>
                <Link to="/app" className={styles.navLink}>
                  Browse
                </Link>
              </div>
              <div className={styles.navItem}>
                <button
                  onClick={() => openModal('supervision')}
                  className={styles.navLink}
                >
                  Supervision
                </button>
              </div>
              <div className={styles.navItem}>
                <button
                  onClick={() => {
                    if (Object.keys(selectionState).length === 0) {
                      openModal({ type: 'supervision', asEmptyQuote: true })
                    } else {
                      openModal({ type: 'quote', selectionState })
                    }
                  }}
                  className={styles.navLink}
                >
                  Quote
                </button>
              </div>
              <ProfileNavItem />
            </div>
          </nav>
        </header>
        {hero}
      </div>
      {children}
    </div>
  )
}

export default Layout

export function ProfileNavItem({ className, anchorClassName }) {
  const { data } = useQuery(QUERY.CURRENT_USER)
  const currentUser = data?.currentUser

  return (
    <div className={cn(styles.navItem, styles.profileNavItem, className)}>
      {currentUser ? (
        <NavLink to="/profile" className={cn(styles.navLink, anchorClassName)}>
          <span className={styles.username}>{currentUser.name}</span>
          <div className={styles.profileImage}>
            <Icon.UserMusic />
          </div>
        </NavLink>
      ) : (
        <NavLink
          to="/login"
          activeClassName={styles.active}
          className={cn(styles.navLink, anchorClassName)}
        >
          Login
        </NavLink>
      )}
    </div>
  )
}

export function SimpleLayout({ children, className }) {
  const { openModal } = useContext(ModalContext)
  const { selectionState } = useContext(SelectionContext)
  let location = useLocation()
  const isLogin = /^\/login/.test(location.pathname)
  return (
    <div className={className}>
      <header className={cn(styles.header, { [styles.isLogin]: isLogin })}>
        <nav className={cn(styles.containerOut, styles.nav)}>
          <div className={styles.menu}>
            <Link to="/" className={styles.logo}>
              <Logo />
            </Link>
          </div>
          <div className={styles.menu}>
            <div className={styles.navItem}>
              <Link to="/app" className={styles.navLink}>
                Browse
              </Link>
            </div>
            <div className={styles.navItem}>
              <button
                onClick={() => openModal('supervision')}
                className={styles.navLink}
              >
                Supervision
              </button>
            </div>
            <div className={styles.navItem}>
              <button
                onClick={() => {
                  if (Object.keys(selectionState).length === 0) {
                    openModal({ type: 'supervision', asEmptyQuote: true })
                  } else {
                    openModal({ type: 'quote', selectionState })
                  }
                }}
                className={styles.navLink}
              >
                Quote
              </button>
            </div>
            <ProfileNavItem />
          </div>
        </nav>
      </header>
      {children}
    </div>
  )
}
